<template>
<div class="warpper">
  <a-layout>
      <a-layout-sider>
        <left-menu/>
      </a-layout-sider>
      <a-layout-content>
        <router-view></router-view>
      </a-layout-content>
 </a-layout>
</div>
 
</template>

<script>
import chart from '@/components/common/Chart.vue';
import Table from './components/PaginationTable.vue';
import moment from 'moment';
import _ from 'underscore';
import leftMenu from './components/leftMenu.vue';
  export default{
    components:{leftMenu},
  }
</script>

<style lang='less' scoped>
  .wrapper{
   .ant-layout-sider{
      background: #F2F2F2;  
      max-width: 250px !important;
      min-width: 250px !important;
      width: 250px !important; 
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/unusualEnterpriseAmount/pollutionInfo.vue